module.exports = __webpack_public_path__ + "static/cf-reg-italic-ext-4b3becee2014cfb084cfb8d0db0ed124.ttf";